export default __webpack_public_path__ + "static/media/eye-grey.dc134c9b.svg";